module.exports = __webpack_public_path__ + "static/media/1155.39efe8a5.jpg";